import {
  GET_MANUAL_ORDER_ERROR_DOWNLOAD,
  GET_MANUAL_ORDER_REQUEST_DOWNLOAD,
  GET_MANUAL_ORDER_SUCCESS_DOWNLOAD,
  CLEAR_CSV_DATA,
  GET_MANUAL_ORDER_RESET_DOWNLOAD,
} from "redux/actions/action-type";

const initialState = {
  csvData: [],
  isDownloadManualOrdersErrorLoading: false,
  isDownloadManualOrdersError: false,
  isDownloadManualOrdersSuccess: false,
};

const downloadManualordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANUAL_ORDER_REQUEST_DOWNLOAD:
      return {
        ...state,
        isDownloadManualOrdersErrorLoading: true,
        isDownloadManualOrdersError: false,
        isDownloadManualOrdersSuccess: false,
      };

    case GET_MANUAL_ORDER_SUCCESS_DOWNLOAD:
      return {
        ...state,
        isDownloadManualOrdersErrorLoading: false,
        csvData: action.payload,
        isDownloadManualOrdersError: false,
        isDownloadManualOrdersSuccess: true,
      };

    case GET_MANUAL_ORDER_ERROR_DOWNLOAD:
      return {
        ...state,
        isDownloadManualOrdersErrorLoading: false,
        csvData: [],
        isDownloadManualOrdersError: true,
        isDownloadManualOrdersSuccess: false,
      };

    case CLEAR_CSV_DATA:
      return {
        ...state,
        csvData: [],
      };

    case GET_MANUAL_ORDER_RESET_DOWNLOAD:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default downloadManualordersReducer;
